import { hookstate } from '@hookstate/core'

const globalGeneralSurveyConfigStore = hookstate({
});

export default globalGeneralSurveyConfigStore;